import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateAssessmentMutation as UpdateAssessmentMutationType,
  UpdateAssessmentMutationVariables,
} from "./__generated__/UpdateAssessmentMutation";

const UpdateAssessmentMutation = loader("./UpdateAssessmentMutation.gql");

type UpdateAssessmentMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted?: (data: UpdateAssessmentMutationType) => void;
}) => ReactElement;

export const UpdateAssessmentMutationProvider: UpdateAssessmentMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateAssessmentMutationType, UpdateAssessmentMutationVariables>(
    UpdateAssessmentMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
